import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { addCustomFilters } from "./actions";
import { AddCustomFiltersCommand } from "./request";

export class AddCustomFiltersHandler extends StoreBaseHandler {
  async handle(request: AddCustomFiltersCommand) {
    try {
      //TODO ensure are valid filters
      this.store.dispatch(addCustomFilters(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
